import { LegalEntity } from './types';
export * from './slice';
export { useAllLegalEntities } from './useAllLegalEntities';
export * from './types';

export const getCountryByLegalEntity = (
  legalEntityId: number,
  legalEntities: LegalEntity[] | undefined,
) =>
  legalEntities?.find(
    (entity: LegalEntity) => entity.fLegalEntityId === legalEntityId,
  )?.fLegalEntityCountry || '';

export const getLegalEntityName = (
  id: number,
  legalEntities: LegalEntity[] | undefined,
): string => {
  if (id === undefined) return '';
  const legalEntity = legalEntities?.find(
    (entity) => entity.fLegalEntityId === id,
  );

  return legalEntity ? legalEntity?.fLegalEntityName : '';
};
